<template>
  <q-page class="q-pa-md">
    <div class="row justify-center">
      <div class="col-12 col-md-10 col-lg-8">

        <div class="row items-center q-mb-md">
          <q-icon name="account_balance" size="2rem" color="primary" class="q-mr-sm" />
          <div class="text-h5 text-weight-bold">Conexão Parceiros Caixa</div>
        </div>

        <q-banner
          v-if="!modulo_contratado"
          class="bg-negative text-white q-mb-md"
          rounded
        >
          <template #avatar><q-icon name="lock" /></template>
          <strong>Módulo não contratado.</strong>
          Este recurso requer a contratação do módulo Conexão Parceiros Caixa.
          Entre em contato com o suporte Dourasoft.
        </q-banner>

        <template v-else>
          <q-banner
            v-if="!modulo_ativo"
            class="bg-info text-white q-mb-md"
            rounded
          >
            <template #avatar><q-icon name="info" /></template>
            Configure o módulo em
            <router-link to="/parametros" class="text-white text-bold">
              Parâmetros → Integrações
            </router-link>
            para começar a usar.
          </q-banner>

          <template v-else>
            <q-banner
              v-if="!conexaoCaixaVinculoAtivo"
              class="bg-warning text-dark q-mb-md"
              rounded
            >
              <template #avatar><q-icon name="warning" /></template>
              Integração ainda não ativada. Acesse
              <router-link to="/parametros" class="text-dark text-bold">
                Parâmetros → Integrações
              </router-link>
              para ativar o agente no computador da lotérica.
            </q-banner>

            <q-banner
              v-else
              class="bg-positive text-white q-mb-md"
              rounded
            >
              <template #avatar><q-icon name="check_circle" /></template>
              <strong>Conectado</strong>
              <span v-if="conexaoCaixaPerfilAtivo"> — {{ conexaoCaixaPerfilAtivo }}</span>
            </q-banner>

            <ConexaoCaixaRelatorios />
          </template>
        </template>

      </div>
    </div>
  </q-page>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import ConexaoCaixaRelatorios from "@/components/ConexaoCaixa/ConexaoCaixaRelatorios.vue";

export default {
  name: "ConexaoCaixa",
  components: { ConexaoCaixaRelatorios },

  computed: {
    ...mapGetters([
      "conexaoCaixaAtivo",
      "conexaoCaixaContratado",
      "conexaoCaixaVinculoAtivo",
      "conexaoCaixaPerfilAtivo",
    ]),
    modulo_ativo()      { return this.conexaoCaixaAtivo; },
    modulo_contratado() { return this.conexaoCaixaContratado; },
  },

  mounted() {
    this.fetchStatusConexaoCaixa();
    this.fetchConexaoCaixaConfig();
  },

  beforeUnmount() {
    this.pararPollingTerminais();
    this.pararPollingRelatorio();
  },

  methods: {
    ...mapActions([
      "fetchStatusConexaoCaixa",
      "fetchConexaoCaixaConfig",
      "pararPollingTerminais",
      "pararPollingRelatorio",
    ]),
  },
};
</script>
